import { Table } from 'antd';
import { formatDate } from '../../../helpers/genericHelper';
import { useState, useEffect } from 'react';
import LoaderComponent from '../../Loader';
import { useMemo } from 'react';
import { convertCentsIntoDollar } from '../../../helpers/genericHelper';

function PaymentAttemptsComponent({ accountId, paymentAttempts = {} }) {
  const [filteredAttempts, setFilteredAttempts] = useState([]);

  const columns = [
    {
      title: 'Attempt Date',
      dataIndex: 'attemptDate',
      key: 'attemptDate',
      render: (text) => formatDate(text, true),
    },
    {
      title: 'Result',
      dataIndex: 'autoPayResult',
      key: 'autoPayResult',
    },
    {
      title: 'Manual',
      dataIndex: 'manual',
      key: 'manual',
      render: (manual) => String(manual),
    },
    {
      title: 'Amount Due',
      dataIndex: 'amountDue',
      key: 'amountDue',
      render: (amount) => convertCentsIntoDollar(amount),
    },
    {
      title: 'Payment Mode',
      dataIndex: 'paymentMode',
      key: 'paymentMode',
    }
  ];
  
  useEffect(() => {
    // load the data if it's not ready and not loading and not in error
    if (!paymentAttempts.isReady && !paymentAttempts.loading && !paymentAttempts.error) {
      paymentAttempts.loadData();
    }
  }, []);

  useEffect(() => {
    // when data is ready, filter the attempts
    if (paymentAttempts.isReady && paymentAttempts.data && paymentAttempts.data.attempts) {
      setFilteredAttempts(paymentAttempts.data.attempts.filter(a =>
        (!accountId || a.accountId === accountId) &&
        !['NO_AMOUNT_DUE', 'PREVIOUS_PAYMENT_IN_PROGRESS', 'ACH_CHECK_SUCCESSFUL', 'STATEMENT_DUE_DATE_IN_FUTURE', 'NO_STATEMENT_GENERATED'].includes(a.autoPayResult)
      ));
    }
  }, [paymentAttempts.isReady, accountId]);

  return (
    !paymentAttempts.isReady || paymentAttempts.loading ? 
      <LoaderComponent /> :
      <Table
        dataSource={filteredAttempts}
        columns={columns}
        rowKey={(record, index) => index}
        pagination={false}
        locale={{ emptyText: 'No Payment Attempts Found' }}
      />
  );
}

export default PaymentAttemptsComponent;